import eth from './eth';
import sol from './sol';

export const chains = {
  eth,
  sol,
};

export enum ChainIconType {
  Eth = 'eth',
  Sol = 'sol',
}

export const getChainIcon = (chain: ChainIconType) => {
  return chains[chain] || eth;
};
